import { lightPalette } from "@theme/light";
export const themePalette = (themeName: string) => {
  return lightPalette;
};